import ChevronRightSvg from '@assets/images/svg/chevron-right.svg';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface ChevronRightIconProps {
    size?: number;
    color?: string;
}

export const ChevronRightIcon: React.FC<ChevronRightIconProps> = ({
    size = 18,
    color = '#1A1A1A',
}) => {
    return (
        <View style={[styles.container, { width: size, height: size }]}>
            <ChevronRightSvg width={size} height={size} color={color} />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default ChevronRightIcon;


